import React from "react";
import "../css/youtube.css";
import { videos } from "../data/videos";
import logo from "../img/logo_escuela.png";

const extractVideoId = (url) => {
  const regExp =
    /(?:youtube\.com\/(?:.*v=|v\/|embed\/)|youtu\.be\/)([^"&?/\s]{11})/;

  const match = url.match(regExp);

  return match ? match[1] : "";
};

const YouTubeVideoList = () => {
  // Agrupar por año
  const groupedVideos = videos.reduce((acc, video) => {
    if (!acc[video.year]) {
      acc[video.year] = [];
    }

    acc[video.year].push(video);

    return acc;
  }, {});

  // Ordenar años descendente
  const years = Object.keys(groupedVideos)
    .map(Number)
    .sort((a, b) => b - a);

  return (
    <section className="videos-container" id="videos-container">
      <h2 className="galeria-title">
        Galería Audiovisual  
      </h2>

      <p className="galeria-subtitle">
        Revive nuestras ceremonias, actividades, proyectos y eventos más importantes.
      </p>

      {years.map((year) => (
        <div key={year} className="year-section">

          <div className="year-header">
            <h2>📅 {year}</h2>
            <p>
              {groupedVideos[year].length}{" "}
              {groupedVideos[year].length === 1 ? "Video" : "Videos"}
            </p>
          </div>

          <div className="video-cards">

            {groupedVideos[year].map((video, index) => {

              const videoId = extractVideoId(video.url);

              return (

                <div
                  key={index}
                  className="youtube-video-card"
                  onClick={() => window.open(video.url, "_blank")}
                >

                  <div className="thumbnail">

                    <img
                      src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                      alt={video.title}
                    />

                    <div className="play-icon">
                      ▶
                    </div>

                  </div>

                  <div className="video-info">

                     <h3>{video.title}</h3>

                    <p className="video-description">
                     Haz clic para ver el video completo.
                     </p>


                  </div>

                </div>

              );

            })}

          </div>

        </div>
      ))}

      <div className="channel-link">

        <img
          src={logo}
          alt="Logo Escuela Nueva Zelandia"
          className="channel-logo"
        />

        <h2 className="galeria-title">
          Canal Oficial de YouTube
        </h2>

        <p className="galeria-subtitle">
          Más de {videos.length} videos disponibles para conocer las actividades
          de nuestra comunidad educativa.
        </p>

        <a
          href="https://www.youtube.com/channel/UCv9kvVQXl1zXASkSQfra55w"
          target="_blank"
          rel="noopener noreferrer"
          className="channel-link-btn"
        >
          Visitar Canal
        </a>

      </div>

    </section>
  );
};

export default YouTubeVideoList;